export default __webpack_public_path__ + "5df78eb4ada22a9db649c8741ed33f27.jpg";